import React from 'react';
import ReactDOM from 'react-dom';
import withAnalytics, { initAnalytics } from 'react-with-analytics';
import { BrowserRouter, withRouter } from "react-router-dom";
import App from './App';
import * as serviceWorker from './serviceWorker';
import ScrollToTop from './components/ScrollToTop';
import './custom.scss';

initAnalytics('UA-135620427-1');

const AnalyticsApp = withRouter(withAnalytics(App));

ReactDOM.render(
    <BrowserRouter>
        <ScrollToTop>
            <AnalyticsApp />
        </ScrollToTop>
    </BrowserRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
